module.exports = __webpack_public_path__ + "static/media/home-intuitive-icon.9dc1e9ce.png";